import { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  Skeleton,
} from "@mui/material";
import MatchPropertyForm from "./MatchPropertyForm";
import { Property } from "../../services/shirts/types";
import ShirtModelService from "../../services/shirts/shirtModelService";
import { EXTRA_DATA as EXTRA_DATA_ENUM } from "../../types/types";
import { Dictionary } from "../../types/types";

interface ItemPropertyFormProps {
  setProperties: Function;
  properties?: Array<Property>;
  errors?: Dictionary<boolean>;
}

const tfMainStyle = {
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "0px",
  },
};

const tfInputProps = {
  disableUnderline: true,
  sx: {
    backgroundColor: "#f4f6f9",
    borderRadius: "3px",
    color: "#6f7d95",
    fontSize: "1rem",
    fontWeight: 500,
    "& .MuiListItemText-root": {
      marginTop: "0px",
      marginBottom: "0px",
    },
  },
};

const ItemPropertyForm = ({
  properties: prop,
  setProperties,
  errors,
}: ItemPropertyFormProps) => {
  const propertyEntry = prop
    ? prop.find(
        (obj) =>
          obj.key === EXTRA_DATA_ENUM.MATCH_WORN ||
          obj.key === EXTRA_DATA_ENUM.MATCH_ISSUED
      )
    : undefined;
  const [propertyOptions, setPropertyOptions] = useState<
    Array<Property> | undefined
  >(undefined);
  const [property, setProperty] = useState<Property | null>(
    propertyEntry ? propertyEntry : null
  );
  const [extraData, setExtraData] = useState<any>(
    propertyEntry
      ? propertyEntry.extra_data
        ? propertyEntry.extra_data
        : null
      : null
  );

  const EXTRA_DATA: Dictionary<any> = {
    [EXTRA_DATA_ENUM.MATCH_WORN]: propertyEntry ? (
      <MatchPropertyForm
        setExtraData={setExtraData}
        data={propertyEntry.extra_data}
        errors={errors}
      />
    ) : (
      <MatchPropertyForm setExtraData={setExtraData} errors={errors} />
    ),
    [EXTRA_DATA_ENUM.MATCH_ISSUED]: propertyEntry ? (
      <MatchPropertyForm
        setExtraData={setExtraData}
        data={propertyEntry.extra_data}
        errors={errors}
      />
    ) : (
      <MatchPropertyForm setExtraData={setExtraData} errors={errors} />
    ),
  };

  const labels: Dictionary<string> = {
    [EXTRA_DATA_ENUM.MATCH_WORN]: "Match Worn",
    [EXTRA_DATA_ENUM.MATCH_ISSUED]: "Match Issued",
  };

  const { getAllProperties } = ShirtModelService();

  const handlePropertyChange = (newId: number) => {
    const foundObject = propertyOptions?.find((obj) => obj.id === newId);
    const foundProperty = foundObject ? foundObject : null;
    setProperty(foundProperty);
  };

  useEffect(() => {
    getAllProperties().then((properties) => {
      let filteredProperties: Array<Property> = [];
      let propFound = properties.find(
        (element) => element.key === EXTRA_DATA_ENUM.MATCH_WORN
      );
      if (propFound) {
        filteredProperties.push(propFound);
      }

      propFound = properties.find(
        (element) => element.key === EXTRA_DATA_ENUM.MATCH_ISSUED
      );
      if (propFound) {
        filteredProperties.push(propFound);
      }

      setPropertyOptions(filteredProperties);
    });
  }, []);

  useEffect(() => {}, [property]);

  useEffect(() => {
    if (property && extraData) {
      let data = { ...property };
      data.extra_data = extraData;
      setProperties(data);
    }
  }, [property, extraData]);

  return (
    <Box>
      <Box sx={{ width: "100%", marginBottom: "1rem" }}>
        {propertyOptions !== undefined ? (
          <FormControl fullWidth>
            <InputLabel>Match worn or issued</InputLabel>
            <Select
              label="Match worn or issued"
              onChange={(event: SelectChangeEvent) =>
                handlePropertyChange(Number(event.target.value))
              }
              value={String(property?.id)}
              sx={tfMainStyle}
              inputProps={tfInputProps}
            >
              {propertyOptions.map((prop) => (
                <MenuItem
                  key={`ItemPropertyOpt_${prop.id}`}
                  value={String(prop.id)}
                >
                  <ListItemText>{labels[prop.key]}</ListItemText>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          <Skeleton variant="rectangular" width={"100%"} height={56} />
        )}
      </Box>
      {property && <Box>{EXTRA_DATA[property.key]}</Box>}
    </Box>
  );
};

export default ItemPropertyForm;
